import React from "react";
import ReactDOM from "react-dom/client";
import "@fontsource/outfit/500.css";
import "@fontsource/outfit/600.css";
import "@fontsource/outfit/700.css";
import "@fontsource/source-sans-3/400.css";
import "@fontsource/source-sans-3/400-italic.css";
import "@fontsource/source-sans-3/600.css";
import "@fontsource/source-sans-3/700.css";
import "@/index.css";
import App from "@/App";
import { prefetch, seed } from "@/hooks/useApi";
import homeSnapshot from "@/data/homeSnapshot.json";

const isHome = window.location.pathname === "/" && !window.location.search;
if (isHome) seed(homeSnapshot);
if (!window.location.pathname.startsWith("/yonetim")) {
  prefetch(["/site", ...(isHome
    ? ["/pages/home", "/announcements?home=true", "/documents/latest?limit=5", "/terminals"] : [])]);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
